import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import NavBar from '../../Components/NavBar/navbar';
import './Auth.css';
import { API_ENDPOINTS } from '../../utils/config';
import { useAuth } from '../../Context/AuthContext';

const Login = () => {
    const navigate = useNavigate();
    const { login, enterGuest } = useAuth();

    const [formData, setFormData] = useState({
        username_or_email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [unverifiedHint, setUnverifiedHint] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setUnverifiedHint(false);

        try {
            const response = await fetch(API_ENDPOINTS.LOGIN, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                login(data.user, data.token);
                if (data.user && data.user.email_verified === false && data.user.user_type !== 'guest') {
                    setUnverifiedHint(true);
                }
                navigate('/');
            } else {
                setError(data.error || 'Login failed');
            }
        } catch (err) {
            console.error('Login request failed:', err);
            setError('Server not responding. Try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleGuestEnter = async () => {
        setLoading(true);
        setError('');
        const result = await enterGuest();
        setLoading(false);
        if (result?.ok) {
            navigate('/');
        } else {
            console.error('Guest login failed', result?.error);
            setError(result?.error || 'Guest login failed. Try again later.');
        }
    };

    return (
        <div className="auth-page">
            <NavBar />
            <div className="auth-page-main">
                <div className="auth-container">
                    <div className="auth-box">
                        <div className="auth-brand">
                            Evolv<span>e<sup>x</sup></span>
                        </div>
                        <h2>Welcome back</h2>
                        <p className="auth-subtitle">Sign in to use your agents and runs</p>

                        {error && <div className="auth-error">{error}</div>}
                        {unverifiedHint && (
                            <div className="auth-banner">
                                Verify your email to create SDK API tokens.{' '}
                                <Link to="/account">Account settings</Link>
                            </div>
                        )}

                        <form onSubmit={handleLogin}>
                            <div className="form-group">
                                <label htmlFor="username_or_email">Username or email</label>
                                <input
                                    id="username_or_email"
                                    type="text"
                                    name="username_or_email"
                                    autoComplete="username"
                                    required
                                    value={formData.username_or_email}
                                    onChange={handleChange}
                                    placeholder="username or you@example.com"
                                />
                            </div>

                            <div className="form-group">
                                <div className="form-label-row">
                                    <label htmlFor="password">Password</label>
                                    <Link to="/forgot-password" className="auth-inline-link">
                                        Forgot password?
                                    </Link>
                                </div>
                                <input
                                    id="password"
                                    type="password"
                                    name="password"
                                    autoComplete="current-password"
                                    required
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Enter your password"
                                />
                            </div>

                            <button type="submit" className="btn-primary" disabled={loading}>
                                {loading ? 'Signing in…' : 'Sign in'}
                            </button>
                        </form>

                        <div className="divider">
                            <span>or</span>
                        </div>

                        <button type="button" onClick={handleGuestEnter} className="btn-secondary" disabled={loading}>
                            Continue as guest
                        </button>

                        <p className="auth-footer">
                            Don&apos;t have an account? <Link to="/auth/register">Register</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
